const getUpsells = (rootState) => rootState.ws.integration.settings.upsells;

export default getUpsells;
